<app-loading
  [loading]="loading"
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Documentos"
      Pagina="Documento"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
            <app-documento-processo-lista></app-documento-processo-lista>
      </div>
    </div>
  </section>
</div>

